"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Graphic = void 0;

var _styles = require("./styles");

var _reactChartjs = require("react-chartjs-2");

require("chart.js/auto");

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

var Graphic = function Graphic(_ref) {
  var data = _ref.data,
      type = _ref.type,
      options = _ref.options;
  var counter = {
    id: "counter",
    beforeDraw: function beforeDraw(chart, args, options) {
      var ctx = chart.ctx,
          _chart$chartArea = chart.chartArea,
          top = _chart$chartArea.top,
          right = _chart$chartArea.right,
          bottom = _chart$chartArea.bottom,
          left = _chart$chartArea.left,
          width = _chart$chartArea.width,
          height = _chart$chartArea.height;
      var x = width / 2;
      var y = height / 2 + options.fontSize * 0.68 / 2;
      var percent = options.value.toString().includes(".") ? options.value.toFixed(2) : options.value;
      ctx.save();
      ctx.beginPath();
      ctx.arc(x, height / 2, 60, 0, 2 * Math.PI);
      ctx.fillStyle = "#E9E9E9";
      ctx.fill();
      ctx.strokeStyle = "#E9E9E9";
      ctx.stroke();
      ctx.font = "".concat(options.fontSize, "px ").concat(options.fontFamily);
      ctx.textAlign = options.textAlign;
      ctx.fillStyle = options.fontColor;
      ctx.fillText(percent + "%", x, y);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactChartjs.Chart, {
      type: type,
      data: data,
      options: options,
      plugins: type === "doughnut" ? [counter] : null
    })
  });
};

exports.Graphic = Graphic;